module.exports = __webpack_public_path__ + "static/img/TH.a1f4aaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping/TH.png
// module id = vnbv
// module chunks = 2